/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import GroupResponse from './GroupResponse';
import UserResponse from './UserResponse';

/**
* The CompanyResponse model module.
* @module model/CompanyResponse
* @version 2020-12-7
*/
export default class CompanyResponse {
    /**
    * Constructs a new <code>CompanyResponse</code>.
    * 会社
    * @alias module:model/CompanyResponse
    * @class
    * @param id {Number} 会社ID
    * @param name {String} 会社名
    * @param address {String} 住所
    * @param tel {String} 電話番号
    * @param remarks {String} 備考
    * @param updatedAt {Number} 最終更新時刻(epoch秒)
    */

    constructor(id, name, address, tel, remarks, updatedAt) {
        
        
        this['id'] = id;
        this['name'] = name;
        this['address'] = address;
        this['tel'] = tel;
        this['remarks'] = remarks;
        this['updatedAt'] = updatedAt;
        
    }

    /**
    * Constructs a <code>CompanyResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CompanyResponse} obj Optional instance to populate.
    * @return {module:model/CompanyResponse} The populated <code>CompanyResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CompanyResponse();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('headOfficeLocation')) {
                obj['headOfficeLocation'] = ApiClient.convertToType(data['headOfficeLocation'], 'String');
            }
            if (data.hasOwnProperty('address')) {
                obj['address'] = ApiClient.convertToType(data['address'], 'String');
            }
            if (data.hasOwnProperty('tel')) {
                obj['tel'] = ApiClient.convertToType(data['tel'], 'String');
            }
            if (data.hasOwnProperty('remarks')) {
                obj['remarks'] = ApiClient.convertToType(data['remarks'], 'String');
            }
            if (data.hasOwnProperty('representative')) {
                obj['representative'] = UserResponse.constructFromObject(data['representative']);
            }
            if (data.hasOwnProperty('children')) {
                obj['children'] = ApiClient.convertToType(data['children'], [GroupResponse]);
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Number');
            }
        }
        return obj;
    }

    /**
    * 会社ID
    * @member {Number} id
    */
    'id' = undefined;
    /**
    * 会社名
    * @member {String} name
    */
    'name' = undefined;
    /**
    * 本社所在地
    * @member {String} headOfficeLocation
    */
    'headOfficeLocation' = undefined;
    /**
    * 住所
    * @member {String} address
    */
    'address' = undefined;
    /**
    * 電話番号
    * @member {String} tel
    */
    'tel' = undefined;
    /**
    * 備考
    * @member {String} remarks
    */
    'remarks' = undefined;
    /**
    * @member {module:model/UserResponse} representative
    */
    'representative' = undefined;
    /**
    * 下位グループ
    * @member {Array.<module:model/GroupResponse>} children
    */
    'children' = undefined;
    /**
    * 最終更新時刻(epoch秒)
    * @member {Number} updatedAt
    */
    'updatedAt' = undefined;




}
